import React from 'react';
import { Row, Col, Spin, Icon } from 'antd';
import '../css/Login.scss';
import '../css/ViewTest.scss';
import service from '../service/apolloclient.service';
import TestPdf from './test/testPdf';
import * as jsPDF from 'jspdf';
import CanvasTestView from './common/canvasTestView';
import Util from './common/utils';
import { Document, Page } from 'react-pdf';
import LocalStorage from '../service/localstorage';
const logo = require('../images/logo.svg');

const ser = new service();
var localstorage = new LocalStorage();

var docx = new jsPDF({
    orientation: 'landscape',
    unit: 'pt',
    format: 'letter'
});

interface PdfState {
    testResult: any;
    testHistory: any;
    data: any;
    loading: any;
    numPages: any;
    pageNumber: any;
    pdfdata: any;
    error: any;
}

export default class PdfReport extends React.Component<{}, PdfState> {

    constructor(props: any ) {
        super(props);
        this.state = {
            testResult: {},
            testHistory: [],
            data: null,
            loading: true,
            numPages: null, 
            pageNumber: 1,
            pdfdata: {},
            error: ''
        };
    }

    componentDidMount () {
        localstorage.clearFileData();
        let data = '';
        let timeout = 0; 
        let interval = setInterval(
            () => {
                if (timeout <= 15) {
                    data = localstorage.getReportData();
                    console.log('reportdata', data);
                    if (data !== '') {
                        clearInterval(interval);
                        this.generatePdfData(data);
                    }
                    timeout ++;
                } else {
                    this.handleError('Something Went Wrong.');
                }
            },  
            1000
        );
    }

    /**
     * Parses the data received as a string from localStorage
     * and converts the data into the format which is needed 
     * by generic pdf generation code.
     */
    public generatePdfData = async (data: any) => {
        var finalData = data.replace(/["][\[]/g, '[');
        finalData = finalData.replace(/[\]]["]/g, ']');
        // this.setState({data: JSON.parse(finalData)});
        // return;
        // let reportData = JSON.parse(finalData);
        let dataObj = this.convertToObject(JSON.parse(finalData));
        var {testResult, userProfile, lastBaseline} = dataObj;
        // let auth = await this.authenticate(userProfile.username, userProfile.password)
        // .catch((error) => this.handleError('Something Went Wrong.'));
        console.log('testresult', testResult);
        if (testResult) {
            testResult.baseline = parseInt(testResult.baseline, 10);
            testResult.score = parseFloat(testResult.score);
            testResult.testtimestamp = parseInt(testResult.testtimestamp, 10);
            testResult['athlete'.toString()] = this.getPlayerInfo(userProfile);
            console.log('baseline', testResult.baseline);
            let baseline = testResult.baseline === 1 ? JSON.parse(JSON.stringify(testResult)) 
            : await this.getLastBaseline(lastBaseline, testResult.testid);
            if (!baseline) {
                this.handleError('Something Went Wrong.');
                return; 
            }
            console.log('generating pdf report');
            this.setState(
                {
                    testResult,
                    testHistory: [baseline],
                    pdfdata: dataObj
                },
                () => this.generatePdf()
            );
        } else {
            this.handleError('Something Went Wrong.');
        }
    }

    /**
     * create playerinfo as the generic pdf generation code needs it in that format
     */
    public getPlayerInfo = (userProfile: any) => {
        var playerInfo = [{}];
        if (userProfile.dob && userProfile.dob !== '') {
            playerInfo.push({ 
                playerinfoname: 'birthdate',
                playerinfovalue: userProfile.dob
            });
        }
        return {
            firstname: userProfile.firstname,
            lastname: userProfile.lastname,
            playerinfo: playerInfo
        };
    }   

    /**
     * converts JSON array to a single JSON object
     */
    public convertToObject = (jsonArray: Array<any>) => {
        let object = jsonArray.reduce(
            function(acc: any, obj: any) {
                let name = Object.keys(obj)[0];
                acc[name] = obj[name];
                return acc;
            }, 
            {}
        );
        return object;
    }

    /**
     * fetch community baseline from server if baseline is not given
     */
    public getLastBaseline = async (lastBaseline: any, testId: any) => {
        if ( lastBaseline && Object.keys(lastBaseline).length !== 0) {
            lastBaseline.baseline = parseInt(lastBaseline.baseline, 10);
            lastBaseline.testtimestamp = parseInt(lastBaseline.testtimestamp, 10);
            return lastBaseline;
        } else {
            let baseline = await ser.getCommunityBaseline()
            .catch(err => this.handleError('Something Went Wrong.'));
            if (baseline) { 
            lastBaseline = JSON.parse(JSON.stringify(baseline[0]));            
            lastBaseline['result_point'.toString()] = this.formatCorrds(lastBaseline.calibaratedtestcoords);
            delete lastBaseline['calibaratedtestcoords'.toString()];
            return lastBaseline;
            } else {
                return baseline; 
            }
        }
    }

    public formatCorrds(coords: any) {
        if (coords !== undefined) {
            let data = coords;
            let formattedData: any = [];
            data.forEach((e: any) => {
                formattedData.push({x: e.eye_x, y: e.eye_y});
            });
            return formattedData;
        }
    }

    public checkIfTestsIsImpaired() {
        return this.state.testResult.range !== undefined ? 
        this.state.testResult.range.indexOf('Poor') !== -1 : false;
    }

    public async authenticate(username: string, password: string) {
        let data = await ser.login(username, password);
        if (data.token) {
            localstorage.setToken(data.token);
            return true;
        }
        return false;
    }

    public setTestCanvas = async (filename: any) => {
        let canvas: any = document.createElement('canvas');
        canvas.width = 1024;
        canvas.height = 768;
        const { testResult, testHistory } = this.state ;
        let baseline = testHistory[0];
        let canvasView = new CanvasTestView(
            canvas, 
            baseline.result_point,
            testResult.result_point,
            testResult.baseline === 1, 
            this.checkIfTestsIsImpaired(), 
            Util.getLocalizedTestType(testResult.range), 
            Util.formatNumber(testResult.score, 2), 
            testResult.result_point === null ? true : false, 
            baseline.result_point === null ? true : false,
            false
        );
        await canvasView.setCanvasView();
        let img = new Image();
        img.src = canvas.toDataURL('image/jpeg', 1.0);
        img.width = 1024 * 0.5;
        img.height = 768 * 0.5;
        return img;
    }

    public generatePdf = () => {
        TestPdf({
            index: 0,
            state: this.state,
            doc: docx,
            isLast: true,
            singleTest: true,
            requireDataURI : true,
            setCanvas: (filename: any) => this.setTestCanvas(filename),
            notifyDownload: (datauri: any ) => this.savePdfData(datauri)
        });
    }
                
    /**
     * save pdf data in localStorage
     */
    public savePdfData = (data: any) => {
                this.setState(
                    {
                data,
                        loading: false
                    }, 
                    () => {
                data = data.substring(data.indexOf('base64,') + 'base64,'.length );
                localstorage.setFileData(data);
                    }
                );
    }
                
    public handleError = (error: string) => {
        this.setState({
            error,
            loading: false
        });
    }

    render() {
        return (
            <div className="Login">
                {   this.state.data == null ?
                    <div className="container">
                        <Row>
                            <Col xs={2} sm={4} md={6} lg={8} xl={9}/>
                            <Col xs={20} sm={16} md={12} lg={8} xl={6}>
                            <div className="externalLogoContainer"><img className="logo" src={logo} /></div>
                            </Col>
                            <Col xs={2} sm={4} md={6} lg={8} xl={9}/>
                        </Row>
                        {   this.state.loading &&
                            <Spin spinning={this.state.loading} style={{position: 'relative', left: '50%'}} /> 
                        }
                        {
                            this.state.error !== '' && 
                            <div className="errordiv"> 
                                <Icon type="exclamation-circle" style={{fontSize: 55, marginTop: 50}} />
                                <p style={{ marginTop: 20, fontSize: 28, marginBottom: 5}} >{this.state.error}</p>
                                <p  style={{ marginTop: 0, fontSize: 20}}>Please go back and try again</p>
                            </div>
                        }
                    </div> : 
                    <div>
                        <Document
                            file={this.state.data}
                            onLoadSuccess={({ numPages }) =>  this.setState({ numPages })}
                        >
                            <Page pageNumber={this.state.pageNumber} />
                        </Document>
                    {/* <p><textarea rows={25} cols={100}>{JSON.stringify(this.state.data)}</textarea></p> */}
                    </div>
                }
            </div>
        );
    }
}

// return obj[key] !== undefined 
//     && obj[key] !== null; });

// public formatCorrds(coords: any) {
//     if (coords !== undefined) {
//         let data = coords;
//         let formattedData: any = [];
//         data.forEach((e: any) => {
//             formattedData.push({x: e.x, y: e.y});
//         });
//         return formattedData;
//     }
// }

// public findKeyInJson = (key: any, reportData: any) => {
//     var data = reportData.find((obj:  any) => Object.keys(obj)[0] === key );
//     return data ? data[key] : null;
// }


// WEBPACK FOOTER //
// ./src/components/PdfReport.tsx